import { DATE_FORMAT } from "@/shared/common/constants";
import type { GroupedHistory, THistoryItem } from "@/shared/common/types";
import { formatDate } from "@/shared/helpers";

type GetFormattedHistoryListParams<T extends THistoryItem> = {
  list: T[];
  beneficiaryKey?: keyof T;
  amountKey?: keyof T;
};

export const getFormattedHistoryList = <T extends THistoryItem>({
  list,
  beneficiaryKey,
  amountKey = "amount",
}: GetFormattedHistoryListParams<T>): GroupedHistory<T>[] => {
  const group: Record<string, T[]> = {};

  list.forEach((item) => {
    const itemData = {
      ...item,
      ...(amountKey ? { amount: item[amountKey] } : { amount: 0 }),
      ...(beneficiaryKey ? { beneficiary: item[beneficiaryKey] } : { beneficiary: "" }),
    };
    const date = formatDate(itemData.creationDate, DATE_FORMAT.YYYY_MM_DD);
    if (group[date]) {
      group[date].push(itemData);
    } else {
      group[date] = [itemData];
    }
  });

  return Object.entries(group).map(([creationDate, transactions]) => ({
    creationDate,
    transactions,
  }));
};


